export default __webpack_public_path__ + "static/media/4384.be0d0fc6.png";